<template>
  <div>
    <el-switch
      @change="changeFn"
      v-model="data.useFileAuditFlag"
      :disabled="authDisabled"
      :active-value="1"
      :inactive-value="0"
      active-color="#ec1c1c"
      inactive-color="#f0f0f0">
    </el-switch>
  </div>

</template>

<script>
  import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
  export default {
    name: "switch-btn",
    props: {
      data: {
        type: Object,
      }
    },

    data() {
      return {

      }
    },
    computed: {
      currentAuthUser() {
        return this.$store.getters.currentAuthUser || {};
      },
      authDisabled(){
        return !this.currentAuthUser.perms.includes(108);
      }
    },
    methods: {
      changeFn(val) {
        console.log(val,'===');
        ApiCorpMethods.FlowController.switchFlowFlag({
          flowId: this.data.flowId,
          useFileAuditFlag: val,
        }).then(res => {

        })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// components/corp-comps/switch-btn.vue